import React from "react";
import { Button } from "@mui/material";
import { ArrowDownward as ArrowDownwardIcon } from "@mui/icons-material";

/**
 * The "back to the bottom" pill (chat-experience 11, D-16). Shown only while the reader has scrolled
 * away from the bottom; carries the number of records that arrived meanwhile. Positioned just above
 * the composer by `.widget-jump-to-latest` (index.css); unmounted when anchored.
 */
export default function JumpToLatest({ visible, unread = 0, onClick, msg }) {
	if (!visible) return null;
	const label = unread > 0
		? msg("chat.new_messages", "{count} new", { count: unread })
		: msg("chat.jump_to_latest", "Jump to latest");
	return (
		<Button
			className="widget-jump-to-latest"
			size="small"
			onClick={onClick}
			aria-label={label}
			startIcon={<ArrowDownwardIcon sx={{ fontSize: 14 }} />}
		>
			{label}
		</Button>
	);
}
